import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import Link from 'next/link';
import React from 'react';

import {
  GA_HEADER_LINK_ACTION,
  GA_HEADER_SPECIFIC_LINK_ACTION,
} from '../../../../containers/home/domain/store/HomeStoreEn';
import { useCitySelectedContext } from '../../../../contexts/city-context/CityContext';
import { LinkLabel } from '../../../types/CommonVM';
import { ga_header_event_prefix } from '../vm/HeaderStore';

interface MobileMenuLinksCmpProps {
  links: LinkLabel[];
  container_class: string;
  child_class: string;
  on_click?: () => void;
}

function MobileMenuLinksCmp({
  links,
  container_class,
  child_class,
  on_click,
}: Readonly<MobileMenuLinksCmpProps>): React.ReactElement {
  const { category } = useCitySelectedContext();

  return (
    <nav className={container_class}>
      {links.map(link => (
        <Link
          href={link.link}
          key={link.link}
          onClick={(): void => {
            on_click?.();
            publishGa4Events(
              ga_header_event_prefix,
              GA_HEADER_LINK_ACTION,
              category,
            );
            publishGa4Events(
              ga_header_event_prefix,
              GA_HEADER_SPECIFIC_LINK_ACTION,
              link.label,
            );
          }}
        >
          <div className={child_class}>{link.label}</div>
        </Link>
      ))}
    </nav>
  );
}

export default MobileMenuLinksCmp;
